export const cardsPriority = [
  'Needs more',
  'Recently viewed',
  'Started',
  'Almost done',
  undefined,
];

export const sortByStatus = (arr, priority) => {
  return !arr?.length
    ? []
    : arr.sort(
        (a, b) =>
          priority.indexOf(a.data?.badge?.text) -
          priority.indexOf(b.data?.badge?.text)
      );
};
